import { createContext } from 'react';

export const personalEndpointContext = createContext<boolean>(false);
